import type { DriveStep } from 'driver.js';

export const settingsTourSteps: DriveStep[] = [
  {
    popover: {
      title: 'Settings Page',
      description: 'Configure your AI translation settings here. Let\'s walk through each option.',
      side: 'over',
      align: 'center',
    },
  },
  // LLM Provider Section
  {
    element: '[data-onboarding="provider-gemini"]',
    popover: {
      title: 'AI Provider Selection',
      description: 'Choose your AI provider here. Click on any provider button to select it for configuration.',
      side: 'bottom',
      align: 'center',
    },
  },
  // Model configuration fields
  {
    element: '[data-onboarding="model-input"]',
    popover: {
      title: 'Model Name',
      description: 'The specific model version to use. Examples:\n- gemini-2.5-flash\n- gpt-4o\n- claude-3-5-sonnet-20241022\n\nClick Edit to change this.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-onboarding="temperature-slider"]',
    popover: {
      title: 'Temperature',
      description: 'Controls creativity vs consistency:\n\n- 0.0-0.3: Very literal, consistent\n- 0.4-0.7: Balanced\n- 0.8+: More creative\n\nRecommended: 0.1 for translations',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="provider-edit-btn"]',
    popover: {
      title: 'Edit Button',
      description: 'Click to enable editing. Make your changes, then click Save.',
      side: 'left',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="provider-activate-btn"]',
    popover: {
      title: 'Set Active',
      description: 'Click to make this provider the active one used for all translations.',
      side: 'left',
      align: 'center',
    },
  },
  // Prompt Section
  {
    element: '[data-onboarding="prompt-dropdown"]',
    popover: {
      title: 'Prompt Selector',
      description: 'Choose which prompt to edit. The star indicates the currently active prompt used for translations.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-onboarding="prompt-name-input"]',
    popover: {
      title: 'Prompt Name',
      description: 'Give your prompt a descriptive name so you can identify it later.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-onboarding="system-prompt-field"]',
    popover: {
      title: 'System Prompt',
      description: 'Defines the AI\'s identity and rules. This is like a "constitution" - it sets the tone, expertise level, and constraints for all translations.\n\nClick on the header to expand and view the full content.',
      side: 'top',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="user-prompt-field"]',
    popover: {
      title: 'User Prompt',
      description: 'Specific task instructions. Tell the AI exactly what to do with each document - formatting, special handling, output requirements.\n\nClick on the header to expand and view the full content.',
      side: 'top',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="prompt-save-btn"]',
    popover: {
      title: 'Save Changes',
      description: 'Save your prompt edits. Keyboard shortcut: Cmd/Ctrl + S. The orange dot shows unsaved changes.',
      side: 'top',
      align: 'start',
    },
  },
  {
    element: '[data-onboarding="prompt-set-active-btn"]',
    popover: {
      title: 'Set as Active',
      description: 'Make this the active prompt. Only the active prompt (star) is used when translating documents.',
      side: 'top',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="prompt-delete-btn"]',
    popover: {
      title: 'Delete Prompt',
      description: 'Remove this prompt. Note: You cannot delete the last remaining prompt.',
      side: 'top',
      align: 'end',
    },
  },
  {
    element: '[data-onboarding="new-prompt-btn"]',
    popover: {
      title: 'Create New Prompt',
      description: 'Create a new prompt template. Useful for different translation styles or document types.',
      side: 'left',
      align: 'center',
    },
  },
  {
    popover: {
      title: 'Settings Complete',
      description: 'Best practices:\n- Use temperature 0.1 for consistent translations\n- Test changes on a few cases first\n- Keep system prompts focused on rules\n- Put specific instructions in user prompts',
      side: 'over',
      align: 'center',
    },
  },
];
